import React, {useEffect} from "react";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ScrollToTop from "./utilis/render/ScrollToTop";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Azienda from "./pages/Azienda";
import InsegneMappa from "./pages/InsegneMappa";
import Contatti from "./pages/Contatti";
import Approccio from "./pages/Approccio";
import DiventaPartner from "./pages/DiventaPartner";
import News from "./pages/News";
import ValoriAziendali from "./pages/ValoriAziendali";
import Volantino from "./pages/Volantino";
import Logistica from "./pages/Logistica";
import Estrazioni from "./pages/Estrazioni";
import CookiePolicy from "./pages/CookiePolicy";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Offerte from "./pages/Offerte";
import SistemaAntiCorruzione from "./pages/SistemaAntiCorruzione";
import NotFound from "./pages/Error";  // <-- import

import "bootstrap/dist/css/bootstrap.min.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./styles/Section.scss";



const App = () => {

    useEffect(() => {
    const { hostname, protocol, pathname, search, hash } = window.location;
    // Se l'host è esattamente "carellidistribuzione.it"
    console.log(hostname);
    if (hostname === 'localhost') {
      // Ricrea l'URL con "www"
      const newUrl = `${protocol}//www.localhost${pathname}${search}${hash}`;
      window.location.replace(newUrl);
    }
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <Routes>
        {/* Route che condividono il Layout */}
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="azienda" element={<Azienda />} />
          <Route path="insegne-mappa" element={<InsegneMappa />} />
          <Route path="pagina-dei-contatti" element={<Contatti />} />
          <Route path="approccio" element={<Approccio />} />
          <Route path="diventa-partner" element={<DiventaPartner />} />
          <Route path="news-ed-eventi" element={<News />} />
          <Route path="volantino" element={<Volantino />} />
          <Route path="estrazioni-biglietti" element={<Estrazioni />} />
          <Route path="logistica" element={<Logistica />} />
          <Route path="news-ed-eventi/:slug" element={<ValoriAziendali />} />
          <Route path="cookie-policy" element={<CookiePolicy />} />
          <Route path="privacy-policy" element={<PrivacyPolicy />} />
          <Route path="sistema-anti-corruzione-aziende" element={<SistemaAntiCorruzione />} />
          <Route path="offerte" element={<Offerte />} />

          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </Router>
  );
};

export default App;
